// ── Korekta zegara klienta względem serwera ─────────────────────────────────
// docs/PAYMENTS-PLAN.md §K4 (przegląd przed Live, runda 3).
//
// Trial/sponsoring/subskrypcja w billing.js porównują terminy z czasem
// LOKALNYM urządzenia — offline-first wymaga, żeby isPro()/getProStatus()
// dało się policzyć synchronicznie, przy każdym renderze, bez round-tripu do
// serwera. Bez korekty zwykły user przesuwający zegar telefonu do przodu
// nigdy nie kończył trialu — to nie wymaga devtools, tylko ustawień systemu.
//
// To NIE jest bariera bezpieczeństwa (§1: paywall to warstwa produktowa, nie
// bezpieczeństwa) — to podniesienie poprzeczki z "każdy, w ustawieniach
// telefonu" na "trzeba wiedzieć, że to pomoże, i to jeszcze obejść offset".
// Offline/błąd wywołania CF → offset zostaje 0, czyli dokładnie dotychczasowe
// zachowanie — degradacja jest cicha i bezpieczna, nie blokuje niczego.
//
// Żyje w pamięci modułu, nie w localStorage: resetuje się przy przeładowaniu
// strony, co jest OK, bo useAuth.js synchronizuje go raz po każdym
// zalogowaniu/przywróceniu sesji — zanim jakikolwiek ekran zdąży źle wygasić
// trial na starym (zerowym) offsecie.
let offsetMs = 0;

/** Wołane przez useAuth.js po odczytaniu czasu z CF getServerTime. */
export function setClockOffset(serverNowMs) {
  offsetMs = serverNowMs - Date.now();
}

/** "Teraz" skorygowane o offset serwera — tego używa billing.js, nie Date.now(). */
export function serverNow() {
  return Date.now() + offsetMs;
}
